import React from 'react'
import PropTypes from 'prop-types'
import Joyride from 'react-joyride'

/* Onbaording (via react-joyride) experience for Attention Index page */
export default class MediaPlanningOnBoarding extends React.Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    run: PropTypes.bool.isRequired
  }

  render () {
    // This fills up the logs quite a bit...so let's disable it by default.
    const debug = false
    return (
      <Joyride
        steps={this._steps()}
        run={this.props.run}
        debug={debug}
        continuous
        controlled
        showProgress
        showSkipButton
      />
    )
  }

  _steps () {
    const common = {
      placement: 'auto',
      placementBeacon: 'auto',
      disableBeacon: false,
      styles: {
        options: {
          zIndex: 10000
        }
      },
      locale: { skip: 'Skip tour' }
    }
    let steps = [
      {
        ...common,
        content: (<p>Welcome to the Diesel Labs Media Planning Page!<br/><br/>The Media Planning page provides insight on the future content that audiences are anticipating.</p>),
        placement: 'center',
        disableBeacon: true,
        target: 'body'
      },
      {
        ...common,
        content: (<p>The Media Plan module highlights how many titles the selected audience is looking forward to broken out by platform and also by time.<br/><br/>The color intensity corresponds to the average affinity score for the titles within the cell, with a darker shade indicating the audience is more favorable toward those titles.</p>),
        target: '#mediaPlanningCalendarWrapper'
      },
      {
        ...common,
        content: (<p>Click on a row or a column to filter for a specific network or month</p>),
        target: '#joyRideCell'
      },
      {
        ...common,
        content: (<p>The Upcoming titles module showcases title detail for the selected rows and columns in the graph to the left. If nothing is selected, all anticipatory titles will be listed in descending order by affinity.<br/><br/>Click on the column titles to sort.<br/>Let's Go!</p>),
        target: '#mediaPlanningTableWrapper'
      }
    ]

    return steps
  }
}
